export default __webpack_public_path__ + "static/media/img02.826ed6b0.jpg";